<template>
  <div class="criteria-facet">
    <div class="criterion-title">
      {{ criterion.title }}
    </div>
    <ul>
      <li v-for="(facet, i) in activeFacets"
          :class="{ active: (current || '').split(',').includes(facet.value) }"
          @click="trigger(facet)"
          :key="facet.value">
        {{ facet.name }}
      </li>
    </ul>
    <a v-if="criterion.facets.length > count"
       class="criterion-more"
       @click="all =! all">
      <span v-if="!all">
        mehr
      </span>
      <span v-else>
        weniger
      </span>
    </a>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'Criterion',
    props: [ 'criterion' ],
    data () {
        return {
            all: false,
            count: 5
        };
    },
    computed: {
        ...mapState({
            language: (state) => state.facets.language,
            alphabet: (state) => state.facets.alphabet,
            outlet: (state) => state.facets.outlet,
            type: (state) => state.facets.type,
            position: (state) => state.facets.position,
            design: (state) => state.facets.design,
            content: (state) => state.facets.content,
            sector: (state) => state.facets.sector,
            audience: (state) => state.facets.audience,
            purpose: (state) => state.facets.purpose,
            method: (state) => state.facets.method,
            arrangement: (state) => state.facets.arrangement,
            dominance: (state) => state.facets.dominance,
        }),
        current: {
            get () {
                switch (this.criterion.type) {
                    case 'language':
                        return this.language;
                    case 'alphabet':
                        return this.alphabet;
                    case 'outlet':
                        return this.outlet;
                    case 'type':
                        return this.type;
                    case 'position':
                        return this.position;
                    case 'design':
                        return this.design;
                    case 'content':
                        return this.content;
                    case 'sector':
                        return this.sector;
                    case 'audience':
                        return this.audience;
                    case 'purpose':
                        return this.purpose;
                    case 'method':
                        return this.method;
                    case 'arrangement':
                        return this.arrangement;
                    case 'dominance':
                        return this.dominance;
                }
                return '';
            },
            set (value) {
                switch (this.criterion.type) {
                    case 'language':
                        this.setLanguage(value);
                        break;
                    case 'alphabet':
                        this.setAlphabet(value);
                        break;
                    case 'outlet':
                        this.setOutlet(value);
                        break;
                    case 'type':
                        this.setType(value);
                        break;
                    case 'position':
                        this.setPosition(value);
                        break;
                    case 'design':
                        this.setDesign(value);
                        break;
                    case 'content':
                        this.setContent(value);
                        break;
                    case 'sector':
                        this.setSector(value);
                        break;
                    case 'audience':
                        this.setAudience(value);
                        break;
                    case 'purpose':
                        this.setPurpose(value);
                        break;
                    case 'method':
                        this.setFunction(value);
                        break;
                    case 'arrangement':
                        this.setArrangement(value);
                        break;
                    case 'dominance':
                        this.setDominance(value);
                        break;
                }
            }
        },
        activeFacets () {
            return this.criterion.facets.filter((facet, i) => {
                return this.all
                    || i < this.count
                    || (this.current || '').split(',').includes(facet.value)
            });
        },
    },
    methods: {
        ...mapActions('facets', [
            'setLanguage',
            'setAlphabet',
            'setOutlet',
            'setType',
            'setPosition',
            'setDesign',
            'setContent',
            'setSector',
            'setAudience',
            'setPurpose',
            'setFunction',
            'setArrangement',
            'setDominance',
        ]),
        trigger (facet) {
            const values = (this.current || '').split(',');
            if (values.includes(facet.value)) {
                values.splice(values.indexOf(facet.value), 1)
            } else {
                values.push(facet.value);
            }
            this.current = values;
        }
    },
};
</script>

<style scoped>
.criterion-title {
  margin-top: 30px;
  font-size: 19px;
  line-height: 20px;
  margin-bottom: 8px;
  font-weight: bold;
  font-family: TheSansUHH-Caps, sans-serif;
  text-align: center;
}

.criteria-facet {
  width: 33%;
}

@media (max-width: 960px) {
  .criteria-facet {
    width: 50%;
  }
}

@media (max-width: 480px) {
  .criteria-facet {
    width: 100%;
  }
}

.criteria-facet ul {
  list-style: none;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  padding: 0;
  margin: 0 10px 5px;
}

.criteria-facet li {
  border: 1px solid #ddd;
  border-bottom: none;
  padding: 10px 20px;
  cursor: pointer;
  user-select: none;
}

.criteria-facet li:last-child {
  border-bottom: 1px solid #ddd;
}

.criteria-facet li:hover {
  background-color: rgba(2, 123, 203, 0.7);
  color: white;
}

.criteria-facet li.active {
  background-color: #027bcb;
  color: white;
}

.criterion-more {
  margin: 0 20px;
  cursor: pointer;
}

.criterion-more:hover {
  text-decoration: underline;
}
</style>
